import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

import { Wrapper, Text } from './NotYouBar.styles';

export const NotYouBar = () => {
  return (
    <Wrapper>
      {/* @ts-expect-error - Material-UI v4 styled component type conflict with React 18 */}
      <Text variant="body1" align="center">
        <FormattedMessage
          id="virtual_graduation.upload.not_you"
          values={{
            a: (chunks: React.ReactNode[]) => (
              // @ts-expect-error - Type conflict between @types/react versions
              <Link component={RouterLink} to="/">
                {chunks}
              </Link>
            ),
          }}
        />
      </Text>
    </Wrapper>
  );
};
